import { isSomething } from '@tokeet-frontend/tv3-platform'
import * as lodash from 'lodash'

export enum InquirySourceType {
  Agoda,
  Airbnb,
  Booking,
  Expedia,
  FlipKey,
  HolidayLettings,
  Tokeet,
  TokeetWebsite,
  TripVillas,
  Unknown,
  VacationHomeRentals,
  VRBO,
  Wimdu,
  Vrbo,
  Marriott,
  GoogleVacationRentals,
}

export type InquirySourceView =
  | 'Agoda'
  | 'Airbnb'
  | 'Booking.com'
  | 'Expedia'
  | 'FlipKey'
  | 'Holiday Lettings'
  | 'AdvanceCM'
  | 'AdvanceCM Website'
  | 'Trip Villas'
  | 'Unknown'
  | 'Vacation Home Rentals'
  | 'VRBO'
  | 'Wimdu'
  | 'Vrbo'
  | 'Marriott'
  | 'Google Vacation Rentals'

export function parseInquirySource(inquirySource: string): { type: InquirySourceType; view: InquirySourceView } {
  if (!isSomething(inquirySource)) {
    return {
      view: null,
      type: null,
    }
  }

  const channels: { condition: RegExp; type: InquirySourceType; view: InquirySourceView }[] = [
    { condition: new RegExp('agoda', 'i'), type: InquirySourceType.Agoda, view: 'Agoda' },
    { condition: new RegExp('airbnb', 'i'), type: InquirySourceType.Airbnb, view: 'Airbnb' },
    {
      condition: new RegExp('^(booking|booking.com|bookingcom)$', 'i'),
      type: InquirySourceType.Booking,
      view: 'Booking.com',
    },
    { condition: new RegExp('expedia', 'i'), type: InquirySourceType.Expedia, view: 'Expedia' },
    { condition: new RegExp('flipkey', 'i'), type: InquirySourceType.FlipKey, view: 'FlipKey' },
    { condition: new RegExp('holiday', 'i'), type: InquirySourceType.HolidayLettings, view: 'Holiday Lettings' },
    { condition: new RegExp('tokeetwebsite', 'i'), type: InquirySourceType.TokeetWebsite, view: 'AdvanceCM Website' },
    { condition: new RegExp('tokeet', 'i'), type: InquirySourceType.Tokeet, view: 'AdvanceCM' },
    { condition: new RegExp('trip', 'i'), type: InquirySourceType.TripVillas, view: 'Trip Villas' },
    { condition: new RegExp('unknown', 'i'), type: InquirySourceType.Unknown, view: 'Unknown' },
    {
      condition: new RegExp('google', 'i'),
      type: InquirySourceType.GoogleVacationRentals,
      view: 'Google Vacation Rentals',
    },
    {
      condition: new RegExp('vacation', 'i'),
      type: InquirySourceType.VacationHomeRentals,
      view: 'Vacation Home Rentals',
    },
    { condition: new RegExp('vrbo', 'i'), type: InquirySourceType.VRBO, view: 'Vrbo' },
    { condition: new RegExp('wimdu', 'i'), type: InquirySourceType.Wimdu, view: 'Wimdu' },
    { condition: new RegExp('marriott', 'i'), type: InquirySourceType.Marriott, view: 'Marriott' },
    {
      condition: <any>{ test: () => true },
      type: InquirySourceType.Unknown,
      view: <any>lodash.startCase(inquirySource),
    },
  ]

  for (let i = 0; i < channels.length; i++) {
    if (channels[i].condition.test(inquirySource)) {
      return {
        type: channels[i].type,
        view: channels[i].view,
      }
    }
  }
}
